module.exports = __webpack_public_path__ + "banquet/components/images/info-circle.2ba8818f02610233530c039083ffd3dd.png";


//////////////////
// WEBPACK FOOTER
// ./banquet/components/images/info-circle.png
// module id = 1706
// module chunks = 1